import { useHasAnyRole, useSession } from '@/hooks/useSession';
import { EQUIPMENT_PERMISSIONS } from '../permissions';

const ADMIN_ROLES = ['full_admin', 'director'];

/** UI gating only — web_api_server enforces the same permissions (full_admin/director bypass). */
export function useEquipmentPermissions() {
  const { user } = useSession();
  const isAdmin = useHasAnyRole(ADMIN_ROLES);
  const permissions = user?.permission_strings ?? [];
  const has = (permission: string) => isAdmin || permissions.includes(permission);
  return {
    canRead: has(EQUIPMENT_PERMISSIONS.read),
    canWrite: has(EQUIPMENT_PERMISSIONS.write),
    canReview: has(EQUIPMENT_PERMISSIONS.review),
  };
}
